import { createAction } from 'redux-actions';

export const setProducts = createAction('SET_PRODUCTS');
